import React from 'react'
import Blog from '../Blog/Blog/Blog';
import Contact from '../Contact/Contact';
import Faq from '../Faq/Faq';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Projects from '../Projects/Projects/Projects';
import Services from '../Services/Services/Services';
import Testimonials from '../Testimonials/Testimonials/Testimonials';

const Home = () => {
    return (
        <div>
            <Header />
            <Projects />
            <Services />
             <Blog />
             <Testimonials />
             <Contact />
             <Faq />
             <Footer />
        </div>
    );
};

export default Home;